<template>
	<div class="px-md-3">
		<v-card-text>
			<v-fab-transition>
				<v-btn color="#ff0000" dark fixed bottom right fab x-large>
					<v-icon>mdi-plus</v-icon>
				</v-btn>
			</v-fab-transition>
		</v-card-text>
		<v-row>
			<v-col cols="4" v-for="index in 4" :key="index">
				<ShopAdministrationCard />
			</v-col>
		</v-row>
	</div>
</template>

<script>
import ShopAdministrationCard from './ShopAdministrationCard';
// import {mapState} from 'vuex'
export default {
	name: 'ShopAdministrationBase',
	data: () => ({
		shops: [
			{
				id: 'Dirección',
				name: 'Serrallo',
				comerciales: 2,
			},
		],
		icons: [
			'mdi-store-outline',
			'mdi-account-key-outline',
			'mdi-email-search',
			'mdi-home-analytics',
		],
	}),
	components: {
		ShopAdministrationCard,
	},
};
</script>
